import _ from 'lodash';
import { useRef } from 'react';

function useDeepMemo<T>(value: T): T {
  const ref = useRef<T>();

  if (!_.isEqual(ref.current, value)) {
      ref.current = value;
  }

  return ref.current as T;
}

export default useDeepMemo;
